// The My Materials card AI button as an eduki Adapt entry point on click_adapt_cta (AI-1806). Also sent as the event's
// internal_path, which the launch banner and modal CTAs leave empty
export const MATERIAL_CARD_ADAPT_CTA_ENTRY_POINT = 'my_materials_card';

// Where a click on the card AI button went: the eduki Adapt dashboard for the eduki_adapt_access_v1 cohort, the KI Tools
// modal for every other German teacher. It stands in for the launch CTAs' `arm`, because the card never reads
// adapt_oct_destination (AI-1774)
export const MATERIAL_CARD_AI_BUTTON_DESTINATIONS = {
    ADAPT_DASHBOARD: 'adapt_dashboard',
    AI_TOOLS_MODAL: 'ai_tools_modal'
} as const;

export type MaterialCardAiButtonDestination =
    (typeof MATERIAL_CARD_AI_BUTTON_DESTINATIONS)[keyof typeof MATERIAL_CARD_AI_BUTTON_DESTINATIONS];
